import styled from '@emotion/styled'
import { Typography } from '@vivaldis/antd-ui'
import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  label: string
  value: ReactNode
}

export const Row: FC<Props> = ({ label, value }) => {
  const [t] = useTranslation('web_ui')

  return (
    <Base>
      <Label>{label}</Label>
      <Value>
        <Typography.Paragraph
          ellipsis={{
            rows: 2,
            expandable: 'collapsible',
            symbol: expanded =>
              expanded
                ? t('view_work_post_sheet_screen_content.see_less')
                : t('view_work_post_sheet_screen_content.see_more')
          }}
          style={{ marginBottom: 0, textAlign: 'right' }}
        >
          {value}
        </Typography.Paragraph>
      </Value>
    </Base>
  )
}

const Base = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;

  & + & {
    border-top: 1px solid ${props => props.theme.gray5};
  }
`

const Label = styled('div')`
  flex: 0 1 45%;
  font-size: 14px;
  line-height: 22px;
  color: ${props => props.theme.gray7};
`

const Value = styled('div')`
  flex: 1 1 55%;
  min-width: 0;
  font-size: 14px;
  line-height: 22px;
  color: ${props => props.theme.gray10};
  white-space: pre-wrap;
  word-break: break-word;
`
